import React, { useState, useRef } from 'react';
import apiClient from '../../Api/axiosConfig';
import './FilePicker.css';

const FilePicker = ({ label, value, onChange, accept }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setIsUploading(true);
    setError('');
    try {
      // A feltöltési célmappát a 'downloads' mappára állítjuk
      const response = await apiClient.post('/file/upload/downloads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // Sikeres feltöltés után meghívjuk a szülő onChange-ét az új URL-lel
      onChange(response.data.path);
    } catch (err) {
      setError(err.response?.data?.message || 'Feltöltési hiba.');
    } finally {
      setIsUploading(false);
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="file-picker-container">
      <div className="label-wrapper">
        <label>{label}</label>
      </div>
      <div className="file-input-group">
        <input 
          type="text" 
          value={value || ''}
          onChange={(e) => onChange(e.target.value)} // Engedélyezzük a kézi beírást is
          placeholder="/downloads/fajlnev.pdf"
        />
        <button type="button" onClick={triggerFileSelect} disabled={isUploading} className="browse-button">
          {isUploading ? 'Feltöltés...' : 'Feltöltés'}
        </button>
        <input 
          type="file" 
          ref={fileInputRef}
          onChange={handleFileChange} 
          accept={accept}
          style={{ display: 'none' }} 
        />
      </div>
      {error && <p className="file-picker-error">{error}</p>}
    </div>
  );
};

export default FilePicker;